import React from 'react';
import ExitingPersistence from '@atlaskit/motion/exiting-persistence';

/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */
var ModalTransition = function ModalTransition(props) {
  var _props$children;
  return /*#__PURE__*/React.createElement(ExitingPersistence, {
    appear: true
  }, //Checking if children are undefined to prevent potential runtime errors in React 17
  (_props$children = props.children) !== null && _props$children !== void 0 ? _props$children : null);
};
export default ModalTransition;